export default "__VITE_ASSET__COe4h1xf__"